import { useState } from 'react';
import { DocumentViewer } from './document-viewer';

// #28/#23/#30 — Encapsula el estado + render del visor inline de documentos para
// reusarlo (Mis Documentos, Lecturas) sin repetir wiring en cada página (ENG-LOC-01).
export function useDocumentViewer() {
  const [viewing, setViewing] = useState<{ id: number; title: string } | null>(null);
  const openDocument = (id: number, title: string) => setViewing({ id, title });
  const viewer = viewing ? (
    <DocumentViewer
      documentId={viewing.id}
      title={viewing.title}
      onClose={() => setViewing(null)}
    />
  ) : null;
  return { openDocument, viewer };
}
